import { PermissionResource } from '@entities/tenant/permission';

import { requirePermission } from '../../../require-permission';

export const driversLoader = requirePermission(PermissionResource.TenantDrivers);
